var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7575 7.50976C3.34328 7.50922 3.00706 7.84457 3.00652 8.25878C3.00598 8.673 3.34133 9.00922 3.75554 9.00976L7.15652 9.0142C7.21175 9.01427 7.25646 9.0591 7.25639 9.11433L7.25196 12.5153C7.25142 12.9295 7.58676 13.2657 8.00098 13.2663C8.41519 13.2668 8.75142 12.9315 8.75196 12.5173L8.75639 9.11628C8.75646 9.06105 8.80129 9.01634 8.85652 9.01641L12.2575 9.02085C12.6717 9.02139 13.0079 8.68604 13.0085 8.27182C13.009 7.85761 12.6737 7.52139 12.2594 7.52085L8.85847 7.51641C8.80325 7.51634 8.75853 7.47151 8.75861 7.41628L8.76304 4.01531C8.76358 3.6011 8.42823 3.26488 8.01402 3.26434C7.5998 3.2638 7.26358 3.59914 7.26304 4.01336L7.25861 7.41433C7.25853 7.46956 7.2137 7.51427 7.15848 7.5142L3.7575 7.50976Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.9e201fc2b6188f0b9bfb4a04e7165ebb.svg";
export { ForwardRef as ReactComponent };